module.exports = __webpack_public_path__ + "img/summarize-background.c900a2a0.png";